<template>
  <div style="padding: 15px">
    <div style="margin-bottom: 20px;">
      <vxe-table
        ref="xTable"
        border
        resizable
        stripe
        highlight-current-row
        highlight-hover-row
        row-id="id"
        :loading="loading"
        :data="tableData"
      >
        <vxe-table-column>
          <vxe-table-column
            field="orderCode"
            title="运单号"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <!-- <el-select
              v-model="listQuery.branchCode"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in branchList"
                :key="item.code"
                :label="item.groupName"
                :value="item.code"
              />
            </el-select> -->
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column
          field="orderCode"
          title="运单号"
          min-width="160"
          sortable
        /> -->
        <vxe-table-column
          field="invoiceCode"
          title="发票号码"
          min-width="160"
          sortable
        />
        <vxe-table-column
          field="sellerName"
          title="销方名称"
          min-width="160"
          sortable
        />
        <vxe-table-column
          field="sellerTaxNo"
          title="销方税号"
          min-width="160"
          sortable
        />
        <vxe-table-column
          field="invoiceAmount"
          title="发票金额（元）"
          min-width="160"
          sortable
        />
        <vxe-table-column
          field="taxAmount"
          title="税额"
          min-width="160"
          sortable
        />
        <vxe-table-column
          field="totalAmount"
          title="价税合计（元）"
          min-width="160"
          sortable
        />
        <vxe-table-column
          field="invoiceType"
          title="发票类型"
          min-width="160"
          sortable
        />
        <vxe-table-column
          field="gmtCreated"
          title="开票时间"
          min-width="160"
          sortable
        />
        <vxe-table-column
          field="entryExitStation"
          title="入口收费站"
          min-width="160"
          sortable
        />
        <vxe-table-column
          field="entryTime"
          title="入站时间"
          min-width="160"
          sortable
        />
        <vxe-table-column
          field="exitTime"
          title="出站时间"
          min-width="160"
          sortable
        />
      </vxe-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckDetail",
  data() {
    return {
      loading: false,
      tableData: [
        {
          orderCode: "YD202312010001",
          invoiceCode: "FP202312010001",
          sellerName: "上海物流科技有限公司",
          sellerTaxNo: "91310000XXXXXXXX1A",
          invoiceAmount: 5000.0,
          taxAmount: 650.0,
          totalAmount: 5650.0,
          invoiceType: "增值税专用发票",
          gmtCreated: "2023-12-01 09:30:00",
          entryExitStation: "沪宁高速入口",
          entryTime: "2023-12-01 10:00:00",
          exitTime: "2023-12-01 14:30:00"
        },
        {
          orderCode: "YD202312010002",
          invoiceCode: "FP202312010002",
          sellerName: "江苏运输集团有限公司",
          sellerTaxNo: "91320000XXXXXXXX2B",
          invoiceAmount: 3800.0,
          taxAmount: 494.0,
          totalAmount: 4294.0,
          invoiceType: "增值税专用发票",
          gmtCreated: "2023-12-01 11:15:00",
          entryExitStation: "沪杭高速入口",
          entryTime: "2023-12-01 12:00:00",
          exitTime: "2023-12-01 16:45:00"
        },
        {
          orderCode: "YD202312010003",
          invoiceCode: "FP202312010003",
          sellerName: "浙江货运服务有限公司",
          sellerTaxNo: "91330000XXXXXXXX3C",
          invoiceAmount: 4200.0,
          taxAmount: 546.0,
          totalAmount: 4746.0,
          invoiceType: "增值税专用发票",
          gmtCreated: "2023-12-01 13:45:00",
          entryExitStation: "杭甬高速入口",
          entryTime: "2023-12-01 14:30:00",
          exitTime: "2023-12-01 19:15:00"
        }
      ]
    };
  },
  created() {},
  methods: {
    formatterBranch({ cellValue }) {
      return "";
      // const item = this.branchList.find(item => item.code === cellValue);
      // return item ? item.groupName : "";
    }
  }
};
</script>

<style scoped></style>
